export default __webpack_public_path__ + "static/media/HRRealCase-mobile-en.7496fac7.jpg";